export default __webpack_public_path__ + "static/media/front.c37980d6.png";